import { css } from '@emotion/css';
import { FormControlLabel, Switch } from '@material-ui/core';
import React from 'react';

export const SwitchWithLabel = ({
  checked,
  onChange,
  label,
  fontSize,
  disabled
}: {
  checked: boolean;
  onChange: (nextChecked: boolean) => void;
  label: React.ReactNode;
  fontSize?: 'normal' | 'small';
  disabled?: boolean;
}) => {
  const classes =
    fontSize === 'small'
      ? { label: css({ fontSize: '0.8125rem' }) }
      : undefined;
  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          color="primary"
          onChange={(ev) => onChange(ev.target.checked)}
          disabled={disabled}
        />
      }
      classes={classes}
      label={label}
      disabled={disabled}
    />
  );
};
